import { Link, useLocation } from "react-router-dom";

// Centralized route-to-breadcrumbs map
const routeToBreadcrumbs = {
  "/shop": [
    { label: "Home", href: "/" },
    { label: "Shop" },
  ],
  "/flowers": [
    { label: "Home", href: "/" },
    { label: "Shop", href: "/shop" },
    { label: "Flowers" },
  ],
  "/accessories": [
    { label: "Home", href: "/" },
    { label: "Shop", href: "/shop" },
    { label: "Accessories" },
  ],
  "/vip": [
    { label: "Home", href: "/" },
    { label: "Shop", href: "/shop" },
    { label: "VIP Collection" },
  ],
  "/build": [
    { label: "Home", href: "/" },
    { label: "Shop", href: "/shop" },
    { label: "Build Your Hamper" },
  ],
  "/about": [
    { label: "Home", href: "/" },
    { label: "About" },
  ],
  "/contact": [
    { label: "Home", href: "/" },
    { label: "Contact" },
  ],
  "/blog": [
    { label: "Home", href: "/" },
    { label: "Blog" },
  ],
  "/terms": [
    { label: "Home", href: "/" },
    { label: "Terms of Agreement" },
  ],
  "/policies": [
    { label: "Home", href: "/" },
    { label: "Policies" },
  ],
  "/faqs": [
    { label: "Home", href: "/" },
    { label: "FAQs" },
  ],
};

function Breadcrumbs() {
  const location = useLocation();
  const path = location.pathname;

  if (path === "/") return null; // Hide on home

  // Fallback: turn /some/page into breadcrumbs
  const fallback = path.split("/").filter(Boolean).map((seg, i, arr) => ({
    label: formatLabel(seg),
    href: i < arr.length - 1 ? "/" + arr.slice(0, i + 1).join("/") : undefined,
  }));

  const breadcrumbs = routeToBreadcrumbs[path] || [{ label: "Home", href: "/" }, ...fallback];

  return (
    <nav className="bg-gray-50 py-2 px-4 text-sm text-gray-600 rounded mb-6 mt-6 max-w-6xl mx-auto">
      <ol className="flex flex-wrap items-center space-x-1">
        {breadcrumbs.map((item, i) => (
          <li key={i} className="flex items-center space-x-1">
            {i > 0 && <span className="mx-1 text-gray-400">/</span>}
            {item.href ? (
              <Link to={item.href} className="text-blue-600 hover:underline font-medium">
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

function formatLabel(segment) {
  return decodeURIComponent(segment)
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default Breadcrumbs;
